import DispatchConstants from '../../constants/DispatchConstants';

const initState = {
  mode: '',
  openLabel: '',
};

const accordionState = (state = initState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_ACCORDION_STATE:
      return { ...state, ...payload };
    default:
      return state;
  }
};

export default accordionState;
